<!-- FileListPopover.vue -->
<template>
  <div @mouseenter="$emit('mouseenter')" @mouseleave="$emit('mouseleave')">
    <transition name="fade-scale">
      <div v-if="showPopover" class="file-list-popover">
        <div v-if="files.length === 0" class="no-files-message">
          <i class="mdi mdi-file-alert-outline"></i>
          ファイルがありません
        </div>
        <div v-else class="file-list">
          <div v-for="(file, index) in files" :key="index" class="file-item">
            <span @click="openFileModal(file, $event)" class="file-link">
              <i class="mdi mdi-file-outline file-icon"></i>
              {{ file.name }}
            </span>
          </div>
        </div>
        <button @click="$emit('close')" class="close-button" aria-label="閉じる">
          <i class="mdi mdi-close"></i>
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FileListPopover',
  props: {
    files: {
      type: Array,
      required: true
    },
  },
  emits: ['open-file', 'mouseenter', 'mouseleave', 'close'],
  data() {
    return {
      showPopover: true,
      timer: null
    }
  },
  watch: {
    files: {
      immediate: true,
      handler(newFiles) {
        this.showPopover = true;
        if (newFiles.length === 0) {
          this.startTimer();
        } else {
          this.clearTimer();
        }
      }
    }
  },
  methods: {
    openFileModal(file, event) {
      const isCtrlClick = event.ctrlKey || event.metaKey;
      if (isCtrlClick) {
        window.open(file.file, '_blank');
      } else {
        this.$emit('open-file', file);
      }
    },
    startTimer() {
      this.clearTimer();
      this.timer = setTimeout(() => {
        this.showPopover = false;
        this.$emit('close');
      }, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    beforeDestroy() {
      this.clearTimer();
    },
  },
}
</script>

<style lang="scss" scoped>
// 共通のスタイル変数
$primary-color: #a00;
$hover-color: #ff4081;
$background-color: #ffffff;
$border-radius: 8px;
$box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
$transition-duration: 0.2s;

.file-list-popover {
  background: $background-color;
  border: 1px solid rgba($primary-color, 0.2);
  border-radius: $border-radius;
  padding: 16px;
  box-shadow: $box-shadow;
  min-width: 250px;
  max-height: 300px;
  overflow-y: auto;
  position: relative;
  backdrop-filter: blur(8px);
  transition: all $transition-duration ease;

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
  }
}

.no-files-message {
  color: #666;
  text-align: center;
  padding: 20px 0;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  i {
    font-size: 20px;
    color: $primary-color;
  }
}

.file-list {
  max-height: 250px;
  overflow-y: auto;
}

.file-item {
  padding: 8px;
  border-radius: 4px;
  transition: background-color $transition-duration ease;

  &:hover {
    background: rgba($primary-color, 0.05);
  }
}

.file-link {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: $primary-color;
  text-decoration: none;
  font-size: 14px;
  transition: all $transition-duration ease;

  &:hover {
    color: $hover-color;
    transform: translateX(2px);
  }
}

.file-icon {
  margin-right: 8px;
  font-size: 18px;
}

.close-button {
  position: absolute;
  top: 8px;
  right: 8px;
  background: transparent;
  border: none;
  color: #666;
  cursor: pointer;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all $transition-duration ease;

  &:hover {
    background: rgba($primary-color, 0.1);
    color: $primary-color;
  }

  i {
    font-size: 16px;
  }
}

.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-scale-enter,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

/* スクロールバーのカスタマイズ */
.file-list::-webkit-scrollbar {
  width: 4px;
}

.file-list::-webkit-scrollbar-track {
  background: rgba($primary-color, 0.1);
  border-radius: 2px;
}

.file-list::-webkit-scrollbar-thumb {
  background: $primary-color;
  border-radius: 2px;
  
  &:hover {
    background: $hover-color;
  }
}
</style>


// WEBPACK FOOTER //
// src/components2/Manage/modal/FileListPopover.vue